export default __webpack_public_path__ + "static/media/DropFR.14b67f7c.PNG";